import { EventType } from '@kurtosys/ksys-app-template/dist/models/eventBus';
import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	'components': {
		'app': {
			'cardProps': {},
			'noDataOptions': {
				'hide': true,
				'hideRow': true,
			},
		},
		'card': {
			'props': {
				'title': 'Daily Prices',
				'titleLevel': 3,
			},
			'queries': {
				'subtitle': {
					'queryOptionsType': 'none',
					'subQueries': [
						{
							'code': 'price',
							'entityType': 'CLSS',
							'format': {
								'options': {
									'day': '2-digit',
									'month': 'long',
									'timeZone': 'UTC',
									'year': 'numeric',
								},
								'type': 'date',
							},
							'index': 0,
							'key': 'as_of_date',
							'queryId': 'date',
							'queryOptionsType': 'statistics',
						},
					],
					'value': 'As of {sub:date}',
				},
			},
		},
		'table': {
			'props': {
				'responsiveMode': 'pivotToCard',
			},
			'queries': {
				'columns': [
					{
						'cellStyle': {
							'padding': {
								'left': '10px',
							},
						},
						'headCellStyle': {
							'padding': {
								'left': '10px',
							},
						},
						'header': {
							'queryOptionsType': 'none',
							'value': 'Price Type',
						},
						'id': {
							'queryOptionsType': 'none',
							'value': 'name',
						},
						'key': {
							'queryOptionsType': 'none',
							'value': 'name',
						},
					},
					{
						'header': {
							'queryOptionsType': 'none',
							'value': 'Unit Price',
						},
						'id': {
							'queryOptionsType': 'none',
							'value': 'unit',
						},
						'key': {
							'queryOptionsType': 'none',
							'value': 'unit',
						},
					},
					{
						'header': {
							'queryOptionsType': 'none',
							'value': '1 Day Change',
						},
						'id': {
							'queryOptionsType': 'none',
							'value': '1daychange',
						},
						'key': {
							'queryOptionsType': 'none',
							'value': '1daychange',
						},
					},
					{
						'header': {
							'queryOptionsType': 'none',
							'value': '1 Day % Change',
						},
						'id': {
							'queryOptionsType': 'none',
							'value': '1daychangeperc',
						},
						'key': {
							'queryOptionsType': 'none',
							'value': '1daychangeperc',
						},
					},
				],
				'rows': [
					{
						'1daychange': {
							'code': 'price',
							'entityType': 'CLSS',
							'format': {
								'options': {
									'currencyDisplay': 'narrowSymbol',
									'maximumFractionDigits': 2,
									'minimumFractionDigits': 2,
								},
								'type': 'currency',
							},
							'index': 0,
							'key': 'mv_change_1_day',
							'queryId': 'market1day',
							'queryOptionsType': 'statistics',
							'subQueries': [
								{
									'code': 'trading_currency',
									'entityType': 'CLSS',
									'key': 'value',
									'queryId': 'currency',
									'queryOptionsType': 'property',
								},
							],
						},
						'1daychangeperc': {
							'code': 'price',
							'entityType': 'CLSS',
							'format': {
								'options': {
									'maximumFractionDigits': 2,
									'minimumFractionDigits': 2,
								},
								'transforms': [
									{
										'operator': 'divide',
										'value': 100,
									},
								],
								'type': 'percent',
							},
							'index': 0,
							'key': 'mv_change_1_day_percent',
							'queryOptionsType': 'statistics',
						},
						'name': {
							'queryOptionsType': 'none',
							'value': 'Market Price',
						},
						'unit': {
							'code': 'price',
							'entityType': 'CLSS',
							'format': {
								'options': {
									'currencyDisplay': 'narrowSymbol',
									'maximumFractionDigits': 2,
									'minimumFractionDigits': 2,
								},
								'type': 'currency',
							},
							'index': 0,
							'key': 'market_price',
							'queryId': 'marketvalue',
							'queryOptionsType': 'statistics',
							'subQueries': [
								{
									'code': 'trading_currency',
									'entityType': 'CLSS',
									'key': 'value',
									'queryId': 'currency',
									'queryOptionsType': 'property',
								},
							],
						},
					},
					{
						'1daychange': {
							'code': 'price',
							'entityType': 'CLSS',
							'format': {
								'options': {
									'currencyDisplay': 'narrowSymbol',
									'maximumFractionDigits': 4,
									'minimumFractionDigits': 4,
								},
								'type': 'currency',
							},
							'index': 0,
							'key': 'nav_change_1_day',
							'queryId': 'nav1day',
							'queryOptionsType': 'statistics',
							'subQueries': [
								{
									'code': 'trading_currency',
									'entityType': 'CLSS',
									'key': 'value',
									'queryId': 'currency',
									'queryOptionsType': 'property',
								},
							],
						},
						'1daychangeperc': {
							'code': 'price',
							'entityType': 'CLSS',
							'format': {
								'options': {
									'maximumFractionDigits': 2,
									'minimumFractionDigits': 2,
								},
								'transforms': [
									{
										'operator': 'divide',
										'value': 100,
									},
								],
								'type': 'percent',
							},
							'index': 0,
							'key': 'nav_change_1_day_percent',
							'queryOptionsType': 'statistics',
						},
						'name': {
							'queryOptionsType': 'none',
							'value': 'NAV Price',
						},
						'unit': {
							'code': 'price',
							'entityType': 'CLSS',
							'format': {
								'options': {
									'currencyDisplay': 'narrowSymbol',
									'maximumFractionDigits': 4,
									'minimumFractionDigits': 4,
								},
								'type': 'currency',
							},
							'index': 0,
							'key': 'net_asset_value',
							'queryId': 'netvalue',
							'queryOptionsType': 'statistics',
							'subQueries': [
								{
									'code': 'trading_currency',
									'entityType': 'CLSS',
									'key': 'value',
									'queryId': 'currency',
									'queryOptionsType': 'property',
								},
							],
						},
					},
				],
			},
		},
	},
	'data': {
		'context': {
			'entityByType': {
				'CLSS': {
					'savedSearchEntity': {
						'inputs': [
							{
								'appInputKey': 'clientCode',
								'savedSearchInputKey': 'ticker',
							},
							{
								'appInputKey': 'culture',
								'savedSearchInputKey': 'culture',
							},
						],
						'key': 'productPage',
					},
				},
			},
			'globalCommentaries': [
				{
					'cultures': [
						'en-CA',
						'fr-CA',
					],
					'global': true,
				},
			],
			'globalDisclaimers': [
				{
					'cultures': [
						'en-CA',
						'fr-CA',
					],
					'global': true,
				},
			],
		},
	},
};
